import React from 'react'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { SimpleLoading, PromotionalFooterPure } from '../../pures'
import SignatureRequestPanelPure from '../../pures/signature-request-panel/signature-request-panel.pure'
import { Tooltip } from '@progress/kendo-react-tooltip'
import './request-inquiry-detail.css'
import { ItemMenuBlueImage, ItemMenuGreenImage } from '../../../assets/logos/icons'
import { useHistory } from 'react-router-dom'

const RequestInquiryDetailView = (props) => {
  const history = useHistory()
  const { t } = useTranslation()

  return (
    <div className='panelStyle-queriesValidations'>
      {(props.loading) ? <SimpleLoading /> :
        <div className={'globalContainerStyles'}>
          <div className='table-card-queriesValidations' >
            <div className="table-queriesValidations" >
              <h3 className="table-title-queriesValidations">{t('queriesAndValidationsView.requestInquiry')}</h3>
            </div>
            <div className="table-wapprer-buttons">
              <Tooltip openDelay={600} position="top" anchorElement="target" tooltipClassName="tooltipGeneralStyle">
                <div style={{ display: 'flex' }}>
                  <span title={t('signatureReceivePanelView2.tooltipTabReceive')} className={`table-filter-buttons table-button-blue ${props.buttonFilterSelectedBlue}`} onClick={() => { }}>
                    <span className={'menuStatusIconStyles'}><img src={ItemMenuBlueImage} alt="icon" width={14}></img></span>{t('signatureReceivePanelView2.tabTitleReceive')}
                  </span>
                </div>
              </Tooltip>

              <Tooltip openDelay={600} position="top" anchorElement="target" tooltipClassName="tooltipGeneralStyle">
                <div style={{ display: 'flex' }}>
                  <span title={t('signatureReceivePanelView2.tooltipTabRequest')} className={`table-filter-buttons table-button-green ${props.buttonFilterSelectedGreen}`} onClick={() => { }}>
                    <span className={'menuStatusIconStyles'}><img src={ItemMenuGreenImage} alt="icon" width={14}></img></span>{t('signatureReceivePanelView2.tabTitleRequest')}
                  </span>
                </div>
              </Tooltip>

              <div className="filter" >
                <div className={'filterContainerStyles'}>
                  <span style={{ paddingRight: '10px' }}>{t('signatureReceivePanelView2.filterby')}</span>
                  <span className="k-icon k-i-filter iconFilterStyles"></span>
                  <select className={'filterSelectStyles'} onChange={() => { }} value={1}>
                    <option value="2">{t('signatureReceivePanelView2.pendingRequest')}</option>
                    <option value="4">{t('signatureReceivePanelView2.completedRequest')}</option>
                    <option value="3">{t('signatureReceivePanelView2.rejectedRequest')}</option>
                    <option value="5">{t('signatureReceivePanelView2.cancelRequest')}</option>
                    <option value="0">{t('signatureReceivePanelView2.allRequest')}</option>
                  </select>
                </div>
              </div>
            </div>
            <SignatureRequestPanelPure
              signatureRequests={[{
                name: 'name',
                description: 'description',
                signRequestStatusId: 'signRequestStatusId',
                createdDate: 'createdDate',
                expirationDate: 'expirationDate',
              }]}
              total={1}
              skip={false}
              take={1}
              loading={false}
              showPagination={true}
              dataStateChange={(params) => console.log('params...')}
              edit={(params) => console.log('params...')}
              seeDetail={'seeDetail'}
              tooltipDetail={'tooltipDetail'}
              tooltipDelete={'tooltipDelete'}
              toggleDialogDeleteRequest={(params) => console.log('params...')}
              view={null}
              visibilityIcon={true}
              setIsShowAutorizationModal={null}
              isHideTrash={true}
              killMe={() => history.push({
                pathname: `/autograph-signature-replicas`
              })
              }
            />
            <div className='btn-contianer' >
              <Link to='/queries-and-validations' >
                <button onClick={props.scrollWindow} className='back-style-queriesValidations'>{t('queriesAndValidationsView.buttonBack')}</button>
              </Link>
            </div>
            <PromotionalFooterPure />
          </div>
        </div>
      }
    </div>
  )
}

export { RequestInquiryDetailView as default }